"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorFormatRegex = void 0;
var ColorFormatRegex;
(function (ColorFormatRegex) {
    ColorFormatRegex["RGB"] = "^#[A-Fa-f0-9]{6}$";
})(ColorFormatRegex = exports.ColorFormatRegex || (exports.ColorFormatRegex = {}));
//# sourceMappingURL=color-format-regex.js.map